import { DniFormView } from './dni/DniFormView'
import { DniSummaryView } from './dni/DniSummaryView'
import { useDniForm } from './dni/useDniForm'

export function DniFormModal(props: { dniId?: string; locationId?: string; locationName?: string; onAdd: () => void }) {
  const form = useDniForm(props)
  return form.mode === `summary` ? <DniSummaryView {...form} /> : <DniFormView {...form} />
}
